import React, { FunctionComponent } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { grayscaleText, whiteText } from "../../styles/theme";

interface ChatHeaderProps {
	onClose: () => void;
	onReset: () => void;
}

const ChatHeader: FunctionComponent<ChatHeaderProps> = ({
	onClose,
	onReset,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "12px 16px",
				backgroundColor: grayscaleText,
			}}
		>
			<Typography sx={{ color: whiteText, fontWeight: "bold" }}>
				Chatbot
			</Typography>
			<Box>
				<IconButton
					size="small"
					onClick={() => onReset()}
					title="Reset conversation"
				>
					<RestartAltIcon sx={{ color: whiteText }} fontSize="small" />
				</IconButton>
				<IconButton size="small" onClick={onClose}>
					<CloseIcon sx={{ color: whiteText }} fontSize="small" />
				</IconButton>
			</Box>
		</Box>
	);
};

export default ChatHeader;
